module.exports = __webpack_public_path__ + "img/OpenRoadAutoStorage-Horizontal-white.b4c1ab9c.png";